<template>
  <!-- 인피니트 리스트 -->
  <vue-infinite-loader
    :fetch="fetch"
    :identifier="identifier"
    item-key="raw.codeId"
    item-text="raw.codeValue"
    :loading="loading"
    :valid="(e) => !!e.raw.codeValue && !!e.raw.codeValue.trim() && e.raw.codeId"
    :search-input="searchInput"
  >
    <template #default="{ item }">
      <code-item-simple-card
        :item="item"
        @pick="pick => $emit('pick', pick)"
      />
    </template>
  </vue-infinite-loader>
</template>

<script>
    import CodeItemSimpleCard from "@/components/items/code/CodeItemSimpleCard";

    export default {
        name: "MFormUserModelList",
        components: {CodeItemSimpleCard},
        props: {
            items: {
                type: Array,
                default: () => [],
            },
            identifier: {
                type: Number,
                default: 0,
            },
            loading: {
                type: Boolean,
                default: false,
            },
            searchInput: {
                type: String,
                default: "",
            },
        },
        methods: {
            async fetch(pageNumber, pageSize) {
                return this.items.slice((pageNumber - 1) * pageSize, (pageNumber * pageSize));
            },
        },
    }
</script>

<style scoped>

</style>